import comp from "./NumberText";
export default comp;
